module.exports = __webpack_public_path__ + "static/media/PC.f9809e9b.svg";